import { z } from "zod";

export const defaultLayout = [
  [
    ["summary", "experience", "education", "projects", "volunteer"],
    [
      "profiles",
      "skills",
      "certifications",
      "languages",
      "awards",
      "publications",
      "interests",
      "references",
    ],
  ],
];

// Schema
export const metadataSchema = z.object({
  template: z.string().default("folio"),
  layout: z.array(z.array(z.array(z.string()))).default(defaultLayout), // pages -> columns -> sections
  css: z.object({
    value: z.string().default(".section {\n\toutline: 1px solid #000;\n\toutline-offset: 4px;\n}"),
    visible: z.boolean().default(false),
  }),
  page: z.object({
    margin: z.number().default(14),
    format: z.enum(["a4", "letter"]).default("a4"),
    options: z.object({
      breakLine: z.boolean().default(true),
      pageNumbers: z.boolean().default(true),
    }),
  }),
  theme: z.object({
    background: z.string().default("#ffffff"),
    text: z.string().default("#171717"),
    primary: z.string().default("#171717"),
  }),
  typography: z.object({
    font: z.object({
      family: z.string().default("Lora"),
      subset: z.string().default("latin"),
      variants: z.array(z.string()).default(["regular", "italic", "600", "700"]),
      size: z.number().default(14),
    }),
    lineHeight: z.number().default(1.35),
    hideIcons: z.boolean().default(true),
    underlineLinks: z.boolean().default(false),
  }),
  notes: z.string().default(""),
});

// Type
export type Metadata = z.infer<typeof metadataSchema>;

// Defaults
export const defaultMetadata: Metadata = {
  template: "folio",
  layout: defaultLayout,
  css: {
    value: ".section {\n\toutline: 1px solid #000;\n\toutline-offset: 4px;\n}",
    visible: false,
  },
  page: {
    margin: 14,
    format: "a4",
    options: {
      breakLine: true,
      pageNumbers: true,
    },
  },
  theme: {
    background: "#ffffff",
    text: "#171717",
    primary: "#171717",
  },
  typography: {
    font: {
      family: "Lora",
      subset: "latin",
      variants: ["regular", "italic", "600", "700"],
      size: 14,
    },
    lineHeight: 1.35,
    hideIcons: true,
    underlineLinks: false,
  },
  notes: "",
};
